import React, { useEffect, useState } from 'react';
import config from './magnolia.config';
import {
  getPageContent,
  getTemplateAnnotations,
} from '../../utilities/functions/magnoliaUtils';
import { EditorContextHelper, EditablePage } from '@magnolia/react-editor';
import mockPageLoaderResponse from '../../utilities/mocks/mockPageLoaderResponse.json';

interface PageLoaderProps {
  pagePath?: string;
  magnoliaContext: any;
  page: any;
  templateAnnotations: any;
}

const initPageLoaderProps: PageLoaderProps = {
  magnoliaContext: null,
  page: null,
  templateAnnotations: null,
};

const checkMainAreaComponents = (area: any) => {
  if (!area?.main || area?.['@name'] === 'fallback-page-loader') return;
  const mainAreaComponentCnt = area['main']['@nodes'].length;
  return mainAreaComponentCnt;
};

function PageLoader(props: any) {
  const [pageLoaderProps, setPageLoaderProps] = useState(initPageLoaderProps);
  const [mainAreaComponentCnt, setmainAreaComponentCnt] = useState(0);
  const nodeName = process.env.REACT_APP_MGNL_APP_BASE;

  useEffect(() => {
    async function loadPage(pagePath?: string) {
      const config = { headers: {} };
      const props: any = {};
      props.nodeName = nodeName;

      // Use magnoliaContext from current page path if no pagePath is provided
      const magnoliaContext = EditorContextHelper.getMagnoliaContext(
        window.location.href,
        nodeName,
        ['en']
      );
      props.magnoliaContext = magnoliaContext;

      if (process.env.REACT_APP_MGNL_IS_MOCK === 'true') {
        props.page = mockPageLoaderResponse;
      } else {
        // Get page content
        const pageContentPath =
          (pagePath ? nodeName + pagePath : magnoliaContext.nodePath) +
          magnoliaContext.search;
        props.page = await getPageContent(pageContentPath);

        // Get template annotations only inside Magnolia WYSIWYG
        if (magnoliaContext.isMagnolia) {
          const templateAnnotationsPath =
            (pagePath ? nodeName + pagePath : magnoliaContext.nodePath) +
            magnoliaContext.search;
          const templateAnnotationsRes = await getTemplateAnnotations(
            templateAnnotationsPath,
            config
          );
          props.templateAnnotations = await templateAnnotationsRes;
        }
      }

      setmainAreaComponentCnt(checkMainAreaComponents(props.page));

      // Dispatch footer date event
      const lastModified = props.page['mgnl:lastModified'];
      if (lastModified) {
        document.dispatchEvent(
          new CustomEvent('updateFooterDate', {
            detail: {
              buildDate: lastModified,
              isMgnlDate: true,
            },
          })
        );
      }

      setPageLoaderProps(props);
    }

    loadPage(props.pagePath);
  }, [nodeName, props.pagePath]);

  useEffect(() => {
    if (typeof props.hasAreaComponents === 'function') {
      props.hasAreaComponents(mainAreaComponentCnt);
    }
  }, [mainAreaComponentCnt]);

  return (
    <>
      {pageLoaderProps.page && (
        <EditablePage
          templateAnnotations={pageLoaderProps.templateAnnotations || {}}
          content={pageLoaderProps.page}
          config={config}
        />
      )}
    </>
  );
}

export default PageLoader;
